module.exports = __webpack_public_path__ + "img/illu-scale-bottom.011eb6c7.svg";